import React, { useState, useRef } from 'react';
import { Popover, PopoverProps, SvgIconProps } from '@one-thd/sui-atomic-components';
import { Info } from '@one-thd/sui-icons';

type HeaderPopoverProps = {
  popover: {
    title: string;
    content: React.ReactNode;
    placement?: 'top' | 'top-start' | 'top-end' | 'bottom' | 'bottom-start' | 'bottom-end' | 'left' | 'left-start' | 'left-end' | 'right' | 'right-start' | 'right-end';
  };
};

export const HeaderPopover: React.FC<HeaderPopoverProps> = ({ popover }) => {
  const iconRef = useRef<HTMLElement | null>(null);
  const [open, setOpen] = useState(false);

  const handlePopoverIconClick: SvgIconProps['onClick'] = (event) => {
    event.stopPropagation();
    setOpen((prev) => !prev);
  };

  const handlePopoverBodyClick: React.MouseEventHandler = (event) => {
    event.stopPropagation();
  };

  const handlePopoverClose: PopoverProps['onClose'] = (event) => {
    event.stopPropagation();
    setOpen(false);
  };

  const idPop = open ? 'simple-popover' : undefined;

  return (
    <div className="sui-flex sui-px-1 sui-fill-primary">
      <Info
        size="small"
        data-testid="InfoIcon"
        ref={iconRef}
        onClick={handlePopoverIconClick}
        color="current"
        aria-describedby={idPop}
      />
      <Popover
        id={idPop}
        open={open}
        anchorEl={iconRef.current}
        onClick={handlePopoverBodyClick}
        onClose={handlePopoverClose}
        title={popover.title}
        placement={popover.placement || 'bottom'}
      >
        {popover.content}
      </Popover>
    </div>
  );
};

HeaderPopover.displayName = 'HeaderPopover';
